import React, { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";

const tone = (v) => (v.startsWith("Implausible") ? "text-slate-500" : v.startsWith("Possible") ? "text-emerald-700" : "text-amber-700");

export function SpaLegacyTab() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/spa-units/reconciliation").then((r) => setD(r.data)).catch(() => setD({ items: [], totals: {} })); }, []);
  if (!d) return <div className="py-10 text-center text-slate-400"><Loader2 className="w-5 h-5 animate-spin inline" /></div>;
  return (
    <div className="space-y-3" data-testid="spa-legacy">
      <div className="rounded-xl border border-rose-200 bg-rose-50 p-3 text-sm text-rose-800">{d.note}</div>
      <div className="flex flex-wrap gap-2 text-sm" data-testid="spa-legacy-totals">
        {Object.entries(d.totals).map(([k, v]) => <span key={k} className="rounded-full bg-white border border-slate-200 px-3 py-1"><b className="tabular-nums">{v}</b> {k === "held" ? "units held in total" : k}</span>)}
      </div>
      <div className="bg-white border border-slate-200 rounded-2xl overflow-x-auto"><table className="w-full text-sm">
        <thead className="bg-slate-50 text-left text-[11px] uppercase text-slate-500"><tr>
          {["Archived product", "Held", "Reserved", "Allocated", "Open serials", "Job links", "Best match in 2026 sheet", "In stock in sheet", "Finding"].map((h) => <th key={h} className="px-3 py-2 whitespace-nowrap">{h}</th>)}</tr></thead>
        <tbody>{d.items.map((x) => (
          <tr key={x.legacy_id} className="border-t border-slate-100 align-top" data-testid={`spa-legacy-${x.legacy_id}`}>
            <td className="px-3 py-2 min-w-[200px]"><div className="font-medium">{x.title}</div><div className="text-xs text-slate-400 font-mono">{x.legacy_id}</div></td>
            <td className="px-3 py-2 tabular-nums font-semibold">{x.held}</td><td className="px-3 py-2 tabular-nums">{x.reserved}</td><td className="px-3 py-2 tabular-nums">{x.allocated}</td>
            <td className="px-3 py-2 tabular-nums">{x.open_serials}</td><td className="px-3 py-2 tabular-nums">{x.job_links}</td>
            <td className="px-3 py-2">{x.matched_new_product || "-"}</td><td className="px-3 py-2 tabular-nums">{x.matched_new_product ? x.spreadsheet_in_stock : "-"}</td>
            <td className={`px-3 py-2 min-w-[220px] text-xs font-medium ${tone(x.verdict)}`}>{x.verdict}</td></tr>))}</tbody>
      </table></div>
    </div>
  );
}
